import axios from 'axios';

import store from '../redux/store';

const authInterceptor = () =>
  axios.interceptors.request.use(
    (request) => {
      const fromStore = store.getState().auth.authData;
      if (fromStore?.token && request.headers) {
        request.headers.Authorization = `Bearer ${fromStore.token}`;
      }

      return request;
    },
    (error) => Promise.reject(error)
  );

export default authInterceptor;
